import React from "react";

export default function Footer() {
  return (
    <div className="row text-center mt-2">
      <p>
        An &nbsp;
        <a href="https://github.com/fenilaphilip/Weather-App.git">
          open-source project
        </a>
        , by Fenila Philip
      </p>
    </div>
  );
}
